import { Analytics } from "../../bookmydesk-api-sdk-typescript-axios";

export const kAnalytics: Analytics = {
  insights: {
    active_check_ins: 144,
    missed_check_ins: 21,
  },
};

export const kAnalyticsForLocation: Analytics = {
  insights: {
    active_check_ins: 144,
    missed_check_ins: 21,
  },
};
